import { Controller, useFormContext } from 'react-hook-form';
import { MenuItem, TextField } from '@client/new/components/basic';
import { CollapsibleSection } from '../primitives/CollapsibleSection';
import { useSectionOpenState } from '../../lib/useSectionOpenState';
import * as styles from './DurationSection.css';
import {
  DURATION_UNIT_OPTIONS,
  ProgramFormValues,
  SESSION_DURATION_OPTIONS,
} from '../../model/programForm.types';

export type DurationSectionProps = {
  isSubmitting?: boolean;
};

export const DurationSection = ({ isSubmitting }: DurationSectionProps) => {
  const { control } = useFormContext<ProgramFormValues>();
  const { isOpen, setIsOpen } = useSectionOpenState();

  return (
    <CollapsibleSection
      title="Duration"
      isOpen={isOpen}
      onOpenChange={setIsOpen}
    >
      <div className={styles.row}>
        <div className={styles.lengthInput}>
          <Controller
            control={control}
            name="durationLength"
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="Length"
                type="number"
                disabled={isSubmitting}
                data-testid="program-form-duration-length"
              />
            )}
          />
        </div>
        <div className={styles.unitSelect}>
          <Controller
            control={control}
            name="durationUnit"
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                select
                size="small"
                disabled={isSubmitting}
                data-testid="program-form-duration-unit"
              >
                {DURATION_UNIT_OPTIONS.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </div>
        <div className={styles.daysInput}>
          <Controller
            control={control}
            name="daysPerWeek"
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                size="small"
                label="Days/week"
                type="number"
                disabled={isSubmitting}
                inputProps={{ min: 1, max: 7 }}
                data-testid="program-form-days-per-week"
              />
            )}
          />
        </div>
        <div className={styles.sessionSelect}>
          <Controller
            control={control}
            name="sessionDuration"
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                select
                size="small"
                label="Min/session"
                disabled={isSubmitting}
                data-testid="program-form-session-duration"
              >
                {SESSION_DURATION_OPTIONS.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </div>
      </div>
    </CollapsibleSection>
  );
};
